import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-hometwo-testimonials',
    templateUrl: './hometwo-testimonials.component.html',
    styleUrls: ['./hometwo-testimonials.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HometwoTestimonialsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "Testimonials",
            title: 'What Our Clients Are Saying?',
            paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.'
        }
    ]
    singleTestimonialsBox: TestimonialsBoxContent[] = [
        {
            clientImg: 'assets/img/testimonials/Jamil-Glenn.png',
            paragraphText: 'When it comes to creativity and innovation, Devotory truly stands out. Their team of highly skilled tech professionals brings unmatched expertise across a wide range of technology stacks. Devotory doesn’t just deliver high-quality, end-to-end products—they go above and beyond by seamlessly integrating them into our systems and offering unparalleled customer support, even beyond project completion. ASA is exclusively powered by Devotory, and that partnership speaks volumes about their excellence. We couldn’t ask for a better tech partner.',
            clientName: 'Jamil Glenn',
            clientDesignation: 'CEO at ASA'
        },
        {
            clientImg: 'assets/img/testimonials/img2.jpg',
            paragraphText: 'Working with Devotory has been a game-changer for our business. Their ability to understand complex requirements and transform them into scalable, cutting-edge solutions is truly impressive. What sets them apart is their commitment to collaboration and customer satisfaction. From brainstorming ideas to implementation and post-launch support, they were with us every step of the way. Their diverse expertise across various technologies allowed us to innovate faster and more efficiently than we thought possible. Devotory is more than a service provider—they’re a partner in our success.',
            clientName: 'Sel',
            clientDesignation: 'CEO at ReportBuilder'
        },
        // {
        //     clientImg: 'assets/img/testimonials/img3.jpg',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna ali. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.',
        //     clientName: 'Sarah Taylor',
        //     clientDesignation: 'CEO at ThemeForest'
        // }
    ]
    testimonialsBtn: Btn[] = [
        {
            link: "/",
            icon: 'flaticon-view',
            text: 'Check Out All Reviews'
        }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class TestimonialsBoxContent {
    clientImg : string;
    paragraphText : string;
    clientName : string;
    clientDesignation : string;
}
class Btn {
    link : string;
    icon : string;
    text : string;
}